import React from 'react';

const Button = React.forwardRef((props, ref) => {
    const defaultClass = "flex justify-center h-[32px] items-center gap-1 focus:ring-2 focus:outline-none font-medium rounded shadow text-sm px-4 py-2 text-center disabled:opacity-60 disabled:pointer-events-none"

    switch (props.target) {
        case "warning":
            return (
                <button ref={ref} {...props}
                        className={defaultClass + " text-white bg-orange-500 hover:bg-orange-600 focus:ring-orange-300 disabled:hover:bg-orange-500 " + (props.col ?? "")}>
                    {props.children}
                </button>
            )
        case "primary":
            return (
                <button ref={ref} {...props}
                        className={defaultClass + " text-white bg-blue-700 hover:bg-blue-800 focus:ring-blue-300 disabled:hover:bg-blue-700 " + (props.col ?? "")}>
                    {props.children}
                </button>
            )
        case "success":
            return (
                <button ref={ref} {...props}
                        className={defaultClass + " text-white bg-green-700 hover:bg-green-800 focus:ring-green-300 disabled:hover:bg-green-700 " + (props.col ?? "")}>
                    {props.children}
                </button>
            )
        case "danger":
            return (
                <button ref={ref} {...props}
                        className={defaultClass + " text-white bg-red-500 hover:bg-red-600 focus:ring-red-300 disabled:hover:bg-red-500 " + (props.col ?? "")}>
                    {props.children}
                </button>
            )
        default:
            return (
                <button ref={ref} {...props}
                        className={defaultClass + " text-gray-700 bg-white hover:bg-gray-200 focus:ring-gray-200 border border-gray-500 disabled:hover::bg-white " + (props.col ?? "")}>
                    {props.children}
                </button>
            )
    }
});

Button.displayName = "Button";

export default Button;
